(function () {
  if (window.__hgInit) return;
  window.__hgInit = true;

  var SEEN = 'hg_popup_seen';
  var FLAG = 'hg_attr_set';
  var ATTR = 'Halloween Giveaway Goodies';
  var lastFocus = null;

  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} }

  function track(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, detail || {}); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, detail || {}); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail || {}); } catch (e) {}
  }

  function anyOpen() { return document.querySelector('.hg-modal.is-open'); }

  function openModal(id, source) {
    var m = document.getElementById(id);
    if (!m) return false;
    if (m.classList.contains('is-open')) return true;
    if (!anyOpen()) lastFocus = document.activeElement;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hg-lock');
    var p = m.querySelector('.hg-modal__panel');
    if (p) p.focus();
    if (id === 'hg-entry-modal') track('giveaway_form_view', { source: source || 'button' });
    return true;
  }

  function closeModal(m) {
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    if (!anyOpen()) {
      document.documentElement.classList.remove('hg-lock');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-hg-open]');
    if (opener) {
      e.preventDefault();
      var which = opener.getAttribute('data-hg-open');
      if (which === 'entry') {
        var src = opener.getAttribute('data-hg-source') || 'unknown';
        track('giveaway_button_click', { location: src });
        sset(SEEN);
        openModal('hg-entry-modal', src);
      } else if (which === 'rules') {
        openModal('hg-rules-modal');
      }
      return;
    }
    var closer = e.target.closest('[data-hg-close]');
    if (closer) {
      var modal = closer.closest('.hg-modal');
      if (modal) closeModal(modal);
      return;
    }
    if (e.target.classList && e.target.classList.contains('hg-modal')) closeModal(e.target);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('.hg-modal.is-open');
    if (open.length) closeModal(open[open.length - 1]);
  });

  /* Auto popup: once per browsing session, after about 12 seconds or 35% scroll, never on cart or checkout. */
  function autoPopup() {
    var root = document.getElementById('hg-root');
    if (!root || root.getAttribute('data-active') !== 'true' || root.getAttribute('data-has-form') !== 'true') return;
    if (window.Shopify && Shopify.designMode) return;
    if (/^\/(cart|checkouts)/.test(location.pathname)) return;
    if (sget(SEEN)) return;
    var done = false;
    var timer;
    function fire() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      if (sget(SEEN) || anyOpen()) return;
      sset(SEEN);
      openModal('hg-entry-modal', 'auto');
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= 0.35) fire();
    }
    timer = setTimeout(fire, 12000);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Order marker: adds "Halloween Giveaway Goodies: YES" to carts with items during the giveaway. */
  function syncAttr() {
    var root = document.getElementById('hg-root');
    if (!root) return;
    var active = root.getAttribute('data-active') === 'true';
    var flagged = false;
    try { flagged = !!localStorage.getItem(FLAG); } catch (e) {}
    if (!active && !flagged) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var cur = (c.attributes || {})[ATTR] || '';
        var want = active ? 'YES' : '';
        if (cur === want) return;
        if (!c.item_count && !cur) return;
        var a = {};
        a[ATTR] = want;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: a })
        }).then(function () {
          try { if (want) localStorage.setItem(FLAG, '1'); else localStorage.removeItem(FLAG); } catch (e) {}
        });
      })
      .catch(function () {});
  }

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var args = arguments;
      var p = originalFetch.apply(this, args);
      try {
        var u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (u.indexOf('/cart/add') > -1) {
          p.then(function (r) { if (r && r.ok) setTimeout(syncAttr, 300); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function init() { autoPopup(); syncAttr(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('turbo:load', init);
})();